import React from 'react'
import PropTypes from 'prop-types'
import './CategoryBanner.scss'

const CategoryBanner = props => {
  let image = {}
  if (props.category.bannerPhoto) {
    image.backgroundImage = `url(${props.category.bannerPhoto.url})`
  }

  return (
    <div className='CategoryCover'>
      <div className='CategoryCover__img' style={image} />
      <div id='categories-detail' className='container-16'>
        <div id='categories-container'>
          <h1 className='CategoryCover__name'>{props.category.title}</h1>
          <div className='CategoryCover__subtitle'>
            {props.category.description}
          </div>
        </div>
      </div>
    </div>
  )
}

CategoryBanner.propTypes = {
  category: PropTypes.object
}

export default CategoryBanner
